/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Nem12ReportRequest
 */
export interface Nem12ReportRequest {
    /**
     * Time in minutes of desired NEM Interval period (eg 5, 15, 30)
     * @type {number}
     * @memberof Nem12ReportRequest
     */
    intervalMinutes?: number;
    /**
     * Report units, default Wh
     * @type {string}
     * @memberof Nem12ReportRequest
     */
    unitOfMeasure?: Nem12ReportRequestUnitOfMeasureEnum;
    /**
     * Date from, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings)
     * @type {string}
     * @memberof Nem12ReportRequest
     */
    dateFrom?: string;
    /**
     * Date to, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings)
     * @type {string}
     * @memberof Nem12ReportRequest
     */
    dateTo?: string;
    /**
     * Report is run for all operational devices in this group. Prefer using DeviceGroupTags instead.
     * @type {string}
     * @memberof Nem12ReportRequest
     */
    deviceGroupTag?: string;
    /**
     * Report is run for all operational devices in the intersection of all of these groups. Clients must provide at least one group they are directly assigned to, eg their org or a site. They may also provide groups they are not directly assigned to, eg ServiceModels
     * @type {Array<string>}
     * @memberof Nem12ReportRequest
     */
    deviceGroupTags?: Array<string>;
}

/**
 * @export
 */
export const Nem12ReportRequestUnitOfMeasureEnum = {
    Wh: "Wh",
    KWh: "kWh",
} as const;
export type Nem12ReportRequestUnitOfMeasureEnum =
    (typeof Nem12ReportRequestUnitOfMeasureEnum)[keyof typeof Nem12ReportRequestUnitOfMeasureEnum];

/**
 * Check if a given object implements the Nem12ReportRequest interface.
 */
export function instanceOfNem12ReportRequest(
    value: object,
): value is Nem12ReportRequest {
    return true;
}

export function Nem12ReportRequestFromJSON(json: any): Nem12ReportRequest {
    return Nem12ReportRequestFromJSONTyped(json, false);
}

export function Nem12ReportRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): Nem12ReportRequest {
    if (json == null) {
        return json;
    }
    return {
        intervalMinutes:
            json["intervalMinutes"] == null
                ? undefined
                : json["intervalMinutes"],
        unitOfMeasure:
            json["unitOfMeasure"] == null ? undefined : json["unitOfMeasure"],
        dateFrom: json["dateFrom"] == null ? undefined : json["dateFrom"],
        dateTo: json["dateTo"] == null ? undefined : json["dateTo"],
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
    };
}

export function Nem12ReportRequestToJSON(
    value?: Nem12ReportRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        intervalMinutes: value["intervalMinutes"],
        unitOfMeasure: value["unitOfMeasure"],
        dateFrom: value["dateFrom"],
        dateTo: value["dateTo"],
        deviceGroupTag: value["deviceGroupTag"],
        deviceGroupTags: value["deviceGroupTags"],
    };
}
